// extracted by mini-css-extract-plugin
export default {"container":"ft-z","heading":"gt-z","text":"ht-z","info":"it-z","link":"jt-z","fullMaxWidth":"kt-z"};